import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ConnectivityView } from '@core/health-check/connectivity.model';

@Component({
  selector: 'rais-api-unavailable-modal',
  imports: [NzAlertModule, NzButtonModule],
  template: `
    <nz-alert
      nzShowIcon
      nzType="error"
      [nzDescription]="alertBody"
      nzMessage="Отсутствует соединение с сервером"
    ></nz-alert>

    <ng-template #alertBody>
      <div>Ожидайте подключения...</div>

      <div class="probe-status">
        <span>Попытка подключения № {{ connectivity.attempt$() }}.</span>
        @if (connectivity.nextProbeInSec$() > 0) {
          <span>Следующая через {{ connectivity.nextProbeInSec$() }} сек.</span>
        }
      </div>

      <button nz-button nzType="link" nzSize="small" class="retry" (click)="connectivity.probeNow()">
        Повторить сейчас
      </button>
    </ng-template>
  `,
  styles: [
    `
      .probe-status {
        margin-top: 8px;
        opacity: 0.65;
      }

      .retry {
        padding-left: 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiUnavailableModalComponent {
  protected readonly connectivity = inject<ConnectivityView>(NZ_MODAL_DATA);
}
